<a class="skip-link" href="#main-content" (click)="skipToMain($event)">{{ 'navigation.skipToMainContent' | transloco }}</a>
<div class="wrapper">
    <app-top-menubar [(isSidenavOpen)]="this.isSidenavOpen"></app-top-menubar>
    <app-system-event-notification></app-system-event-notification>
    <app-side-menu [isSidenavOpen]="this.isSidenavOpen" class="flex-item-no-padding"></app-side-menu>

    <div class="notification-container">
        @for(notification of notifications; track notification.id) {
        @if(notification.order?.orderTypeID === 'AssetSearch') {
            <app-asset-search-notification [notification]="notification"></app-asset-search-notification>
        } @else {
            <app-notification [notification]="notification"></app-notification>
        }
        }
    </div>
</div>